import Carousel from './Carousel';
import Swiper, { Scrollbar } from 'swiper';
Swiper.use([Scrollbar]);

export default class CarouselData extends Carousel {
	constructor(elm) {
		super(elm);
		this.init();
	}

	init() {
		this.swiper = new Swiper(this.swiperContainer, {
			init: false,
			threshold: 2,
			slidesPerView: 'auto',
			centeredSlides: true,
			spaceBetween: -14,
			grabCursor: true,
			watchOverflow: true,
			scrollbar: {
				el: this.scrollbar,
				draggable: false,
				hide: false,
			},
			breakpoints: {
				1200: {
					enabled: false,
					centeredSlides: false,
					spaceBetween: 0,
				},
			},
		});

		this.swiper.on('breakpoint', () => this.checkEnabled());

		this.swiper.init();
		this.checkEnabled();
	}

	checkEnabled() {
		if (this.swiper.enabled) {
			return;
		}

		this.swiper.slideTo(0, 0, false, true);
	}
}
